import { pushSnowplow, toTeamsFeatureSchema } from '../snowplow'
import { ACTION_TARGETS, ACTION_TARGET_TYPES, ACTION_TYPES, VIEWS, VIEW_TYPES } from './teamsEvents'

// TODO Move the rest of the team members related event publishers to here (from teamsEventPublishers.js)

export const publishClickedExcludeMemberFromRemoval = memberId =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.CONFIRM_REMOVE,
      VIEW_TYPES.DIALOG,
      ACTION_TYPES.CLICKED,
      ACTION_TARGETS.EXCLUDE,
      ACTION_TARGET_TYPES.BUTTON,
      memberId,
    ),
  )

export const publishClickedCheckMember = (actionTarget, value) =>
  pushSnowplow(
    toTeamsFeatureSchema(
      VIEWS.MEMBERS,
      VIEW_TYPES.TABLE,
      ACTION_TYPES.CLICKED,
      actionTarget,
      ACTION_TARGET_TYPES.CHECKBOX,
      value,
    ),
  )
